module.exports = "/images/ny-blck-10.jpg";